import { checkHandleFormat, handleAvailableFor, isHandleRecord } from '@guildite/domain/handles';

import type { HandleAvailability, HandleOwnerRef, HandlesPort } from './ports.ts';

// Handles are public (handles/{handle}), so availability is a plain read. The
// Worker still checks again when the handle is claimed.
export function createHandles({ readHandleRecord, now = () => Date.now() }: {
  readHandleRecord: (handle: string) => Promise<Record<string, unknown> | null>;
  now?: () => number;
}): HandlesPort {
  return {
    async check(input: string, owner: HandleOwnerRef): Promise<HandleAvailability> {
      const format = checkHandleFormat(input);
      if (!format.ok) return { state: 'invalid', handle: format.handle, message: format.message };
      const record = await readHandleRecord(format.handle);
      if (owner.id && isHandleRecord(record) && record.type === owner.type && record.id === owner.id) {
        return { state: 'yours', handle: format.handle, message: record.primary ? `@${format.handle} is your current handle.` : `@${format.handle} was yours; you can take it back.` };
      }
      const claimant = { type: owner.type, id: owner.id || '\u0000new' };
      return handleAvailableFor(record, claimant, now())
        ? { state: 'available', handle: format.handle, message: `@${format.handle} is available.` }
        : { state: 'taken', handle: format.handle, message: `@${format.handle} is taken. Try another.` };
    },
  };
}
